export const STRINGS_CADERNOCONFORMIDADE = {
    NAV_CADERNO_CONFORMIDADE: "Caderno de Conformidade",
    NAV_REGISTRO_CADERNO_CONFORMIDADE: "Registros",
    NAV_REGISTERS: "Cadastros",
    NAV_REGULATORIO: "Responsáveis Regulatório",

    NAV_REGISTRO_CADERNO_CONFORMIDADE_VEGETACAO: "Caderno de Conformidade Casa-de-Vegetação/CAGES",

    SEARCH_CADERNO_CONFORMIDADE_VEGETACAO: "Consulta de Caderno de Conformidade - Vegetação",
    REGISTER_CADERNO_CONFORMIDADE_VEGETACAO: "Cadastro de Caderno de Conformidade - Vegetação",
    EDITION_CADERNO_CONFORMIDADE_VEGETACAO: "Edição de Caderno de Conformidade  - Vegetação",

    SEARCH_REGULATORIO: "Consulta de Responsável do Regulatório",
    REGISTER_REGULATORIO: "Cadastro de Responsável do Regulatório",
    EDITION_REGULATORIO: "Edição de Responsável do Regulatório",

    BLOCK_ONE: "1. Dados Principais",
    BLOCK_TWO: "2. Conferência e Upload de Documentos Obrigatórios",
    BLOCK_THREE: "3. Planejamento",
    BLOCK_THREE_ONE: "3.1. Checklist Pré-Plantio",
    BLOCK_THREE_TWO: "3.2. Plantio",
    BLOCK_THREE_THREE: "3.3. Checklist Pós-Plantio",
//    BLOCK_FOUR: "4. Condução do Ensaio",
    BLOCK_FOUR: "4. Manutenção do Ensaio",
    BLOCK_FIVE: "5. Amostragem",
    BLOCK_SIX: "6. Colheita",
    BLOCK_SIX_ONE: "6.1. Checklist Pré-Colheita",
    BLOCK_SIX_TWO: "6.2. Colheita",
    BLOCK_SIX_THREE: "6.3. Checklist Pós-Colheita",
    BLOCK_SEVEN: "7. Limpeza das Instalações",
    BLOCK_EIGHT: "8. Destruição e Descarte",
    BLOCK_NINE: "9. Fiscalizações",
    BLOCK_TEN: "10. Reportes Incidentes e/ou acidentes com OGM",
    BLOCK_ELEVEN: "11. Anotações",

    BLOCK_LIMPEZA_EQUIPAMENTOS: "Limpeza dos Equipamentos",


    CADERNO_CONFORMIDADE_VEGETACAO_FIELD_TO_SPECIFY: "Este campo deve ser preenchido",

    ANOTACOES_MODAL_TITLE: "Anotações Gerais",
    PLANTIOS_MODAL_TITLE: "Formulário de Registro de Plantio",
    REGISTRO_AMOSTRAGEM_MODAL_TITLE: "Formulário de Registro de Amostragem",
    REGISTRO_COLHEITA_MODAL_TITLE: "Formulário de Registro de Colheita",
    REGISTRO_FISCALIZACAO_MODAL_TITLE: "Formulário de Registro de Fiscalização",
    DATA_PLANTIO_MODAL_TITLE: "Formulário de Datas de Plantio",
    PESSOAS_ENVOLVIDAS_PLANTIO_MODAL_TITLE: "Formulário de Pessoas Envolvidas no Plantio",
    LIMPEZADESTRUICAO_MODAL_TITLE: "Formulário de limpeza de maquinários/equipamentos utilizados na destruição e descarte",
    DATACOLHEITA_MODAL_TITLE: "Data da colheita",
    PESSOAS_ENVOLVIDAS_COLHEITA_MODAL_TITLE: "Formulário de Pessoas Envolvidas na Colheita",
    DESCARTE_MODAL_TITLE: "Formulário de Destruição e Descarte",
    RESPONSAVEIS_DESCARTE_MODAL_TITLE: "Registro do (s) Responsável (is) pela Destruição e Descarte",
    RESPONSAVEIS_REPORTE_MODAL_TITLE: "Registro do (s) Responsável (is) pela Notificação de Liberação Não Intencional",
    INSPECAOEQUIPAMENTOS_MODAL_TITLE: "Formulário de Registro de Limpeza e Inspeção de Equipamentos",
    LIMPEZAINSTALACOES_MODAL_TITLE: "Formulário de Registro de Limpeza das Instalações",
    ATIVIDADE_MANUTENCAO_MODAL_TITLE: "Formulário de Registro de Atividades de Manutenção (Tratos Culturais)",

    CADERNO_CONFORMIDADE_VEGETACAO_APROVE_TITLE: "Deseja aprovar o Caderno de Conformidade?",
    CADERNO_CONFORMIDADE_VEGETACAO_APROVE_BODY_MSG: "Essa ação não poderá ser desfeita.",
    CADERNO_CONFORMIDADE_VEGETACAO_APROVE_SUCCESS: "Caderno de Conformidade aprovada com sucesso",
    CADERNO_CONFORMIDADE_VEGETACAO_APROVE_REGULATORIO_TITLE: "Deseja aprovar a Finalização do Caderno Digital pelo Regulatório?",
    CADERNO_CONFORMIDADE_VEGETACAO_APROVE_REGULATORIO_BODY_MSG: "Essa ação não poderá ser desfeita.",
    CADERNO_CONFORMIDADE_VEGETACAO_APROVE_REGULATORIO_SUCCESS: "Finalização do Caderno Digital aprovada pelo Regulatório com sucesso",
    CADERNO_CONFORMIDADE_VEGETACAO_CANCEL_TITLE: "Deseja cancelar o Caderno de Conformidade?",
    CADERNO_CONFORMIDADE_VEGETACAO_CANCEL_BODY_MSG: "Essa ação não poderá ser desfeita. Insira o motivo do cancelamento abaixo:",
    CADERNO_CONFORMIDADE_VEGETACAO_CANCEL_SUCCESS: "Caderno de Conformidade cancelado com sucesso",
    CADERNO_CONFORMIDADE_VEGETACAO_CORRECTION_TITLE: "Deseja solicitar a correção da criação do Caderno de Conformidade?",
    CADERNO_CONFORMIDADE_VEGETACAO_CORRECTION_BODY_MSG: "Essa ação não poderá ser desfeita.",
    CADERNO_CONFORMIDADE_VEGETACAO_CORRECTION_CONFIRMATION_MSG: "Enviar",
    CADERNO_CONFORMIDADE_VEGETACAO_CORRECTION_SUCCESS: "Solicitação de correção realizada com sucesso",

    CADERNO_CONFORMIDADE_VEGETACAO_ENVIO_CIBIO_TITLE: "Deseja enviar a solicitação de finalização do caderno para análise e aprovação da CIBio?",

    CADERNO_CONFORMIDADE_VEGETACAO_COMPLETE_TITLE: "Deseja concluir o o Caderno de Conformidade?",
    CADERNO_CONFORMIDADE_VEGETACAO_COMPLETE_BODY_MSG: "Essa ação não poderá ser desfeita.",
    CADERNO_CONFORMIDADE_VEGETACAO_COMPLETE_CONFIRMATION_MSG: "Confirmar",
    CADERNO_CONFORMIDADE_VEGETACAO_COMPLETE_SUCCESS: "Caderno de Conformidade concluído com sucesso",

}